import { useState } from 'react';

import { CANVAS_OBJECT_TYPE_PREFIX } from '~/core/constants';
import { drawingTool } from '~/core/engine/DrawingTool';
import { UserDesignOperation } from '~/core/enums';
import { useRegisterUserAction } from '~/core/hooks/useRegisterUserAction';
import { EdgeModel } from '~/core/models';
import { useAppDispatch, useAppSelector } from '~/redux/hooks';
import {
  selectSelectedCornerRadius,
  updateSelectedCornerRadius,
} from '~/redux/slices/cornerRadii';
import { updateNeedRedrawCanvas } from '~/redux/slices/drawingShape';
import {
  selectIsApplySameEdgeActive,
  updateUserSelectedEdge,
} from '~/redux/slices/edge';
import { selectFabricCanvas } from '~/redux/slices/fabric';
import { useDrawingShapeContext } from '~contexts';

export const useSidePanelEdgeTab = () => {
  const dispatch = useAppDispatch();

  const {
    getters: {
      drawingShapes,
      activeDrawingShape,
      areThereShapesInTheDrawingArea,
    },
    handlers: { updateDrawingShapes },
  } = useDrawingShapeContext();

  const { registerUserAction } = useRegisterUserAction();

  const applySameEdge = useAppSelector(selectIsApplySameEdgeActive);

  const selectedCornerRadius = useAppSelector(selectSelectedCornerRadius);

  const canvas = useAppSelector(selectFabricCanvas);

  const selectManualEdge = (edge: EdgeModel) => {
    const updatedDrawingShapes = drawingShapes.map((shape) =>
      applySameEdge || shape.id === activeDrawingShape?.id
        ? { ...shape, edge }
        : shape
    );

    dispatch(updateUserSelectedEdge(edge));
    updateDrawingShapes(updatedDrawingShapes);
    dispatch(updateNeedRedrawCanvas(true));

    // remove corner radius circles and reset the selected corner status
    if (selectedCornerRadius && canvas) {
      drawingTool.removeObjectByName(
        canvas,
        CANVAS_OBJECT_TYPE_PREFIX.SELECTION_CIRCLE
      );
      dispatch(updateSelectedCornerRadius(selectedCornerRadius));
    }
    registerUserAction(UserDesignOperation.MODIFY_EDGE);
  };

  const [optionIndexOn3DModal, setOptionIndexOn3DModal] = useState<
    number | undefined
  >();

  return {
    modalFor3DCarousel: {
      isOpen: optionIndexOn3DModal !== undefined,
      optionIndex: optionIndexOn3DModal,
      setOptionIndex: setOptionIndexOn3DModal,
      close: () => setOptionIndexOn3DModal(undefined),
    },
    selectManualEdge,
    areThereShapesInTheDrawingArea,
    applySameEdge,
  };
};
